import React from "react";
import { Provider } from "react-redux";
import store from "../store";
import styled from "styled-components";
import { rhythm } from "../utils/typography";

const LayoutWrapper = styled.div`
  max-width: 516px;
  padding: ${rhythm(0.6)};
  margin: auto;
  text-align: center;
`;
const Layout: React.FC = ({ children }) => {
  return (
    <Provider store={store}>
      <LayoutWrapper>{children}</LayoutWrapper>
    </Provider>
  );
};

export default Layout;
